import posthog from "posthog-js";
import {isRunningInDevMode} from "navigation-common/firebase-config";
import {TenantDetector} from "../common/TenantDetector";


class PostHogService {

    tenantKey: string = "";
    hasBeenGrouped: boolean = false;

    constructor() {
        this.initPostHog();
    }

    private initPostHog() {
        posthog.init('phc_NVqUuvRGx0pRHCNuJgujCGBe6l8iCQzCjwm4iC9N0VU', {
            api_host: 'https://eu.posthog.com',
            autocapture: false,
            capture_pageview: false,
            persistence: "localStorage"
        });
    }

    private groupEvent() {
        // prevent sending group event multiple times
        if (this.hasBeenGrouped) {
            return;
        }

        this.tenantKey = TenantDetector.getTenantKey();
        posthog.group("Tenant", this.tenantKey, {
            tenantKey: this.tenantKey
        });

        this.hasBeenGrouped = true;
    }

    async logEvent(eventName: AnalyticsEvents) {
        if (isRunningInDevMode()) {
            return;
        }

        this.groupEvent();
        posthog.capture(eventName, {
            tenantKey: this.tenantKey
        });
    }
}

export const postHogService = new PostHogService();

export enum AnalyticsEvents {
    ADMIN_NAVI_SETTINGS_SAVE_CLICKED = "admin/navi/settings/save/clicked",
    USER_NAVI_ITEM_LVL1_CLICKED = "user/navi/item/lvl1/clicked",
    ADMIN_REVIEW_BANNER_REVIEW_CLICKED = "admin/banner/review/review/clicked",
    ADMIN_REVIEW_BANNER_REWARD_CLICKED = "admin/banner/review/reward/clicked",
    ADMIN_REVIEW_BANNER_HIDE_CLICKED = "admin/banner/review/hide/clicked",
}
